import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { updateSubmissionByKey } from '../actions';
import { Checkbox } from 'react-bootstrap';

const AdditionalCoverageOptionalForm = (props) => {
    const { submission, addlCoverageName, optionalForm } = props;
    let additionalCoverage = {};
    if (
        submission?.coverages?.gl?.additional &&
        submission.coverages.gl.additional[addlCoverageName]
    ) {
        additionalCoverage = submission.coverages.gl.additional[addlCoverageName];
    }

    let isSelected = false;
    if (
        submission.optionalForms &&
        submission.optionalForms[optionalForm.formKey] &&
        (submission.optionalForms[optionalForm.formKey].isSelected === true ||
            submission.optionalForms[optionalForm.formKey].isSelected === 'true')
    ) {
        isSelected = true;
    }

    useEffect(() => {
        if (additionalCoverage.selected !== true) {
            /**
             * Reset Optional Form data if associated AdditionalCoverage is deselected
             **/
            if (
                submission.optionalForms &&
                submission.optionalForms[optionalForm.formKey] &&
                submission.optionalForms[optionalForm.formKey].isSelected === true
            ) {
                props.dispatch(
                    updateSubmissionByKey({
                        key: 'optionalForms',
                        value: {
                            ...submission.optionalForms,
                            [optionalForm.formKey]: {
                                isSelected: false,
                            },
                        },
                    })
                );
            }
        }
    }, [additionalCoverage.selected]);

    const handleFormSelectionOnChange = (evt) => {
        if (evt.target.value) {
            props.dispatch(
                updateSubmissionByKey({
                    key: 'optionalForms',
                    value: {
                        ...submission.optionalForms,
                        [evt.target.value]: {
                            isSelected: evt.target.checked,
                        },
                    },
                })
            );
        }
    };

    return (
        <div className="addlCoverageOptionalFormsContainer">
            <Checkbox
                className="addlCoverageOptionalFormCheckbox"
                onChange={handleFormSelectionOnChange}
                value={optionalForm.formKey}
                checked={isSelected}
                disabled={!additionalCoverage.selected}
            >
                {optionalForm.label}
            </Checkbox>
        </div>
    );
};

const mapStateToProps = (state) => ({
    submission: state.app.submission,
});

const connectedAdditionalCoverageOptionalForm = connect(mapStateToProps)(AdditionalCoverageOptionalForm);
export { connectedAdditionalCoverageOptionalForm as AdditionalCoverageOptionalForm };
